<template lang="pug">
v-list(flat)
  v-list-item.px-6
    .text-md.font-semibold {{ $t('customize_column') }}
  v-list-item.px-6
    v-list-item-action.mr-2
      y-checkbox(input-value="true" disabled)
    v-list-item-content
      .text-sm {{ $t('name') }}
  v-list-item-group
    v-list-item.px-6(v-for="option in options" :key="options.name")
      v-list-item-action.mr-2
        y-checkbox(v-model="option.enable")
      v-list-item-content(@click.prevent="toggle(option)")
        .text-sm.capitalize {{ option.field_name | fieldNameDisplay }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['type'],
  computed: {
    ...mapGetters({ 
      fields: 'customers/getAllFields',
      donorFields: 'donation/getAllFields',
      clinicFields: 'clinic/getPatientFields'
    }),
    options() {
      if (this.type === 'donor') {
        return this.donorFields
      } else if (this.type === 'patient') {
        return this.clinicFields
      } else
      return this.fields
    }
  },
  methods: {
    toggle(option) {
      option.enable = !option.enable
    }
  }
}
</script>